import { List } from '../List'
import { CommonWork } from '../CommonWork'

export class StateAwardParent extends List {
  constructor(obj) {
    super(StateAward, obj)
  }
}

export class StateAward {
  constructor(obj = {}) {
    this.id = obj?.id || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.awardDate = obj?.awardDate || null
    this.awardFounder = obj?.awardFounder || null
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      awardDate: this.awardDate,
      awardFounder: this.awardFounder
    }
  }
}
